import { render, staticRenderFns } from "./ProductsServicesPane.vue?vue&type=template&id=6258ab2e&"
import script from "./ProductsServicesPane.vue?vue&type=script&lang=ts&"
export * from "./ProductsServicesPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6258ab2e')) {
      api.createRecord('6258ab2e', component.options)
    } else {
      api.reload('6258ab2e', component.options)
    }
    module.hot.accept("./ProductsServicesPane.vue?vue&type=template&id=6258ab2e&", function () {
      api.rerender('6258ab2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/ProductsServicesPane.vue"
export default component.exports